module.exports = __webpack_public_path__ + "static/media/ico_profile.ece9c6b1.png";